import { component } from 'picoapp'
import Cookies from 'js-cookie'
import '@/lib/jquery-global.js';

export default component((node, ctx) => {

    if (Cookies.get('promo') == null) {

        jQuery(node).slideDown('fast', function() {
            var h = $('#promo').outerHeight();
            $('.__spacer').height(h);

            jQuery('.form-container').css('top', h)
        });

        jQuery('body').addClass('promo--active')

        var h = $('#promo').outerHeight();
        $('.__spacer').height(h);

        $( window ).resize(function() {
            var h = $('#promo').outerHeight();
            $('.__spacer').height(h);

            jQuery('.form-container').css('top', h)
        });

    }

    jQuery('.promo-x').click(function() {
        jQuery(node).slideUp();
        Cookies.set('promo', 'hide');
        $('.__spacer').hide();
        jQuery('body').removeClass('promo--active')
    });

})
